module.exports = {
  SERVER_URL: process.env.NODE_ENV === 'production' ? 'https://morganpage-api.herokuapp.com' : 'http://localhost:1337',
  LIMIT: 15
};